"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const menu_style_1 = require("../../components/menu/menu.style");
exports.CSS = {
    container: 'c-UpdateFormCollections',
    isLoading: 'c-UpdateFormCollections--IsLoading',
    content: 'c-UpdateFormCollections__Content',
    contentSecond: 'c-UpdateFormCollections__Content__second',
    list: 'c-UpdateFormCollections__List',
    menu: 'c-UpdateFormCollections__Menu',
    warningContainer: 'c-UpdateFormCollections__Warning',
    warningTitle: 'c-UpdateFormCollections__Warning__Title',
    warningBody: 'c-UpdateFormCollections__Warning__Body',
    warningList: 'c-UpdateFormCollections__Warning__List',
};
exports.Style = {
    [exports.CSS.container]: {
        width: '1000px',
    },
    [exports.CSS.isLoading]: {
        display: 'flex',
        'justify-content': 'center',
    },
    [exports.CSS.content]: {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-around',
    },
    [exports.CSS.contentSecond]: {
        display: 'flex',
        'align-items': 'baseline',
        'justify-content': 'space-between',
    },
    [exports.CSS.list]: {
        'list-style-type': 'none',
        'padding-left': 0,
    },
    [exports.CSS.menu]: {
        width: '600px',
        position: 'absolute',
        [`& .${menu_style_1.CSS.menu}`]: {
            right: 'auto',
            width: '100%',
        },
    },
    [exports.CSS.warningTitle]: {
        color: 'red',
        'font-size': '2rem',
        'padding-bottom': '1rem',
    },
    [exports.CSS.warningBody]: {
        'padding-bottom': '1rem',
    },
    [exports.CSS.warningList]: {
        'padding-bottom': '1rem',
    },
};
//# sourceMappingURL=collection.form.modal.style.js.map